import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const UsersPage = async () => import('@/pages/UsersPage.vue');
const UserFormPage = async () => import('@/pages/UserFormPage.vue');

export default function getUsersRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'users',
      component: UsersPage,
      meta: {
        title: 'Users',
        useIn: ['navigation-tabs'],
      },
      path: '/users',
    },
    {
      name: 'create-user',
      component: UserFormPage,
      meta: {
        title: 'Create user',
      },
      path: '/users/create',
      props: {
        action: {
          type: CrudActionType.CREATE,
        },
      },
    },
    {
      name: 'edit-user',
      component: UserFormPage,
      meta: {
        title: 'Edit user',
      },
      path: '/users/edit/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-user',
      component: UserFormPage,
      meta: {
        title: 'Clone user',
      },
      path: '/users/clone/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
